import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFiles: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="files, documents"><path d="M7.75 2.75H15.25L20.25 7.75V18.25H7.75V2.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M17.25 18.25V21.25H4.75V5.75H7.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M15.25 3.24927V7.7499H19.7459" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconFiles;
